import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setInfo(info) {
  return Cookies.set('userInfo', info)
}
export function getInfo(info) {
  return Cookies.get('userInfo')
}
export function removeInfo() {
  return Cookies.remove('userInfo')
}
export function getUpToken() {
  return Cookies.get('setUpToken')
}

export function setUpToken(token) {
  return Cookies.set('setUpToken', token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeUpToken() {
  return Cookies.remove(TokenKey)
}

export function setSchool(school) {
  return Cookies.set('school', school)
}
export function getSchool() {
  return Cookies.get('school')
}
export function removeSchool() {
  return Cookies.remove('school')
}
export function setSchoolItem(schoolItem) {
  return Cookies.set('schoolItem', schoolItem)
}
export function getSchoolItem() {
  return Cookies.get('schoolItem')
}
export function removeSchoolItem() {
  return Cookies.remove('schoolItem')
}